var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      staticClass: "collectionPopupContainer",
      staticStyle: {
        background: "#404E55",
        width: "100%",
        "max-width": "300px",
        height: "100%",
      },
      attrs: {
        "offset-y": "",
        attach: "",
        "close-on-content-click": false,
        "open-on-hover": "",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "v-layout",
                _vm._g(
                  _vm._b(
                    { attrs: { "align-center": "", "full-height": "" } },
                    "v-layout",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _c(
                    "v-flex",
                    { attrs: { xs1: "", "mr-1": "", "ml-1": "" } },
                    [
                      _c("v-icon", { attrs: { color: _vm.mainColor } }, [
                        _vm._v(_vm._s(_vm.mainLens)),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { xs8: "" } }, [
                    _c("span", { staticClass: "caption font-weight-bold" }, [
                      _vm._v("WXP Collaboration Collector"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs1: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            text: "",
                            icon: "",
                            color: "grey lighten-1",
                            loading: _vm.loading,
                          },
                          on: { click: _vm.refreshStatus },
                        },
                        [_c("v-icon", [_vm._v("far fa-sync")])],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        { staticStyle: { border: "0" }, attrs: { width: "300px" } },
        [
          _c(
            "v-card-text",
            [
              !_vm.workerSessions || !_vm.workerSessions.length
                ? _c("span", [
                    _vm._v(
                      "\n        The WXP Collaboration Collector is not detected. Please follow the instructions to setup, download and install or check connections.\n      "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.workerSessions || !_vm.workerSessions.length
                ? _c("span", { staticClass: "subheading" }, [
                    _c("br"),
                    _vm._v("What is the WXP Collaboration collector?\n      "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.workerSessions || !_vm.workerSessions.length
                ? _c("span", [
                    _c("br"),
                    _vm._v(
                      "The WXP Collaboration data collector collects technical communication logs to us that provide our monitoring and analytic services.\n        It requires constant network access and will always be running to ensure connectivity.\n      "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-expansion-panels",
                { attrs: { "rounded-0": "" } },
                _vm._l(_vm.workerSessions, function (session) {
                  return _c(
                    "v-expansion-panel",
                    {
                      key: session.id,
                      attrs: { popout: "" },
                      model: {
                        value: _vm.panels,
                        callback: function ($$v) {
                          _vm.panels = $$v
                        },
                        expression: "panels",
                      },
                    },
                    [
                      _c(
                        "v-expansion-panel-header",
                        [
                          _c(
                            "v-layout",
                            {
                              staticStyle: { "margin-left": "-10px" },
                              attrs: { "align-center": "" },
                            },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: _vm.getLensColor(session),
                                      },
                                    },
                                    [_vm._v("fas fa-circle")]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-flex", [
                                session.hostName || session.hostname
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "caption",
                                        staticStyle: {
                                          "white-space": "nowrap",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            session.hostName || session.hostname
                                          ) +
                                            " (v " +
                                            _vm._s(_vm.brokerVersion(session)) +
                                            ")"
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !session.hostName && !session.hostname
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "caption",
                                        staticStyle: {
                                          "white-space": "nowrap",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "v " +
                                            _vm._s(_vm.brokerVersion(session)) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              session.minorVersion >= 4.4
                                ? _c(
                                    "v-flex",
                                    [
                                      _vm.brokerConnected(session)
                                        ? _c(
                                            "v-icon",
                                            { attrs: { size: "12" } },
                                            [_vm._v("far fa-link")]
                                          )
                                        : _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                size: "12",
                                                color: "red",
                                              },
                                            },
                                            [_vm._v("far  fa-unlink")]
                                          ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-expansion-panel-content",
                        { staticClass: "small-text" },
                        [
                          _c(
                            "v-card",
                            [
                              _c("v-card-text", [
                                _c("p", [
                                  _vm._v(
                                    "Service Account: " +
                                      _vm._s(_vm.getUserName(session.updatedBy))
                                  ),
                                ]),
                                _vm._v(" "),
                                session.collectorDir
                                  ? _c("p", [
                                      _vm._v(
                                        "Collector Directory: " +
                                          _vm._s(session.collectorDir)
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "Running Since: " +
                                      _vm._s(
                                        _vm.formatDateTime(session.startDate)
                                      )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "Last Updated: " +
                                      _vm._s(
                                        _vm.formatDateTime(session.updatedDate)
                                      )
                                  ),
                                ]),
                                _vm._v(" "),
                                session.defaultIpAddress
                                  ? _c("p", [
                                      _vm._v(
                                        "Machine IP: " +
                                          _vm._s(session.defaultIpAddress)
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                session.os
                                  ? _c("p", [
                                      _vm._v(
                                        "OS: " +
                                          _vm._s(
                                            session.os.includes("Windows")
                                              ? "Windows"
                                              : session.os
                                          )
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                  Platform Version: " +
                                      _vm._s(session.version) +
                                      "\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v("AppType: " + _vm._s(session.appType)),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v("Session ID: " + _vm._s(session.id)),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }